<template>
  <div class="wrapper">
    <!-- 1.顶部标题-->
    <el-row class="mg_bt_10">
      <h3 class="title">
        <div class="block">
          <span>填单列表</span>
        </div>
      </h3>
    </el-row>
    <!-- 2.工具栏 -->
    <el-row type="flex">
      <el-form inline
               size="small">
        <el-form-item>
          <el-date-picker class="filter-item" type="daterange" v-model="queryDate" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-input class="selectInput"
                    v-model="searchField"
                    style="width: 240px"
                    placeholder="客户姓名/电话">
            <!--<svg slot="suffix"-->
            <!--@click="currentChange(1)"-->
            <!--class="icon"-->
            <!--aria-hidden="true">-->
            <!--<use xlink:href="#iconsearchicon" />-->
            <!--</svg>-->
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-select filterable
                     v-model="skillGroup"
                     size="small"
                     @change="changeSeatsGroup">
            <el-option key="all"
                       label="所有技能组"
                       value="all"></el-option>
            <el-option v-for="item in skillGroup_options"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select filterable
                     v-model="seatsId"
                     size="small">
            <el-option key="all"
                       label="所有坐席"
                       value="all"></el-option>
            <el-option v-for="item in seats_options"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="phoneSelect"
                     size="small">
            <el-option v-for="item in phoneSelectOptions"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="currentChange(1)">查询</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button icon="el-icon-upload2"
                     @click="dialogVisible = true">导入填单</el-button>
        </el-form-item> -->
        <el-form-item>
          <el-button icon="el-icon-download" @click="exportOrderLog" :disabled="isDisabled">导出填单</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="请选择EXCLE文件导入"
                 :visible.sync="dialogVisible"
                 width="30%">
        <span>
          <el-upload class="upload-demo"
                     :headers="headers"
                     accept='application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
                     :action="uploadUrl"
                     :auto-upload="false"
                     :on-change="getFileName"
                     :data="{fileName:fileName}"
                     ref="upload"
                     drag
                     :limit="1"
                     :multiple="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip"
                 slot="tip">可导入文件格式：XLS,XLSX</div>
          </el-upload>
        </span>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary"
                     @click="submitUpload">确 定</el-button>
        </span>
      </el-dialog>
    </el-row>
    <el-scrollbar class="scrollbar-wrap">
      <!-- 3.表格区 -->
      <el-row>
        <el-table style="width: 100%"
                  :data="tableData">
          <el-table-column label="序号"
                           type="index"
                           width="80">
          </el-table-column>
          <el-table-column label="表单编号"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_span">{{scope.row.id}}</span>
            </template>
          </el-table-column>
          <el-table-column label="会话ID"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_span">{{scope.row.sessionId}}</span>
            </template>
          </el-table-column>
          <el-table-column label="咨询时间"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_span">{{scope.row.createdTime}}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="客户类别"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span :class="scope.row.status === 'VIP客户' ? 'text-warning' : ''">VIP客户</span>
            </template>
          </el-table-column> -->
          <el-table-column label="单据类型"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_span">{{scope.row.orderUnit}}</span>
            </template>
          </el-table-column>
          <el-table-column label="服务类别"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_span">{{getShowName(3,scope.row.billType)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="坐席"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="table_span">{{scope.row.createdBy}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-tooltip class="item"
                          effect="light"
                          content="查看"
                          placement="bottom">
                <el-button @click="openDetail(scope.row)"
                           type="text">
                  <svg class="icon icon-bianji"
                       aria-hidden="true">
                    <use xlink:href="#iconxiangqing" />
                  </svg>
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <PageComponent v-bind:init_item="pageBuild"
                       @currentPage="currentChange" />
      </el-row>
      <!-- 底部分页栏 -->
      <el-row style="float: right">
        <!--        <el-pagination class="pageStyle" background layout="total, prev, pager, next, jumper" :page-size.sync="pageSize" :current-page.sync="pageNum" :total="total" @current-change="handleCurrentChange"></el-pagination>-->
      </el-row>
    </el-scrollbar>
    <el-drawer :visible.sync="drawer"
               :direction="direction"
               :modal="false"
               title="工单详情">
      <el-scrollbar style="height: 100%;margin-right: -20px;padding-bottom: 20px">
        <div>
          <div class="subtitle-border">客户信息</div>
          <el-form :inline="true"
                   size="small"
                   label-width="84px"
                   label-position="right">
            <el-row>
              <el-col :span="12">
                <el-form-item label="客户姓名">
                  <span>{{orderLogDetail.clientName}}</span>
                  <span v-if="!orderLogDetail.clientName || orderLogDetail.clientName === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="性别">
                  <span>{{orderLogDetail.clientSex}}</span>
                  <span v-if="!orderLogDetail.clientSex || orderLogDetail.clientSex === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="联系电话">
                  <span>{{orderLogDetail.clientPhone}}</span>
                  <span v-if="!orderLogDetail.clientPhone || orderLogDetail.clientPhone === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <div class="subtitle-border">车辆信息</div>
          <el-form size="small"
                   label-width="84px"
                   label-position="right">
            <!--            <el-form-item label="车主姓名">-->
            <!--              <span>{{orderLogDetail.ownerName}}</span>-->
            <!--            </el-form-item>-->
            <el-row>
              <el-col :span="12">
                <el-form-item label="车牌号">
                  <span>{{orderLogDetail.carId}}</span>
                  <span v-if="!orderLogDetail.carId || orderLogDetail.carId === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="VIN">
                  <span>{{orderLogDetail.carVin}}</span>
                  <span v-if="!orderLogDetail.carVin || orderLogDetail.carVin === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--<el-form-item label="车主姓名">
                  <span>{{orderLogDetail.clientName}}</span>
                </el-form-item>-->
                <!--            <el-form-item label="VIN">-->
                <!--              <span>{{orderLogDetail.carVin}}</span>-->
                <!--            </el-form-item>-->
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆品牌">
                  <span>{{orderLogDetail.carBrand}}</span>
                  <span v-if="!orderLogDetail.carBrand || orderLogDetail.carBrand === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <!--            <el-form-item label="发动机号">-->
                <!--              <span>{{orderLogDetail.carEngineId}}</span>-->
                <!--            </el-form-item>-->
              </el-col>
              <el-col :span="24">
                <el-form-item label="车系">
                  <span v-if="orderLogDetail.carSeries && orderLogDetail.carSeries !== ''">{{JSON.parse(orderLogDetail.carSeries).baseCarSeriesName}}</span>
                  <span v-else
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车型">
                  <span>{{orderLogDetail.carModel}}</span>
                  <span v-if="!orderLogDetail.carModel || orderLogDetail.carModel === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <div class="subtitle-border">会话信息</div>
          <el-form size="small"
                   label-width="70px"
                   label-position="right">
            <el-row>
              <el-col :span="24">
                <el-form-item label="摘要">
                  <span v-html="orderLogDetail.sessionRemark"
                        style="white-space: pre-line;"></span>
                  <span v-if="!orderLogDetail.sessionRemark || orderLogDetail.sessionRemark === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <!--            <el-form-item label="摘要2">-->
                <!--              <span>{{orderLogDetail.sessionRemark2}}</span>-->
                <!--            </el-form-item>-->
              </el-col>
              <el-col :span="24">
                <el-form-item label="客户诉求">
                  <span v-html="orderLogDetail.sessionRequire"
                        style="white-space: pre-line;"></span>
                  <span v-if="!orderLogDetail.sessionRequire || orderLogDetail.sessionRequire === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="会话内容">
                  <div>
                    <span v-html="orderLogDetail.sessionQuestion"
                          style="white-space: pre-line;"></span>
                    <p v-if="!orderLogDetail.sessionQuestion || orderLogDetail.sessionQuestion === ''"
                       class="text-light">暂无信息</p>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="坐席回答">
                  <span v-html="orderLogDetail.sessionAnswer"
                        style="white-space: pre-line;"></span>
                  <span v-if="!orderLogDetail.sessionAnswer || orderLogDetail.sessionAnswer === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <div class="subtitle-border">单据信息</div>
          <el-form size="small"
                   label-width="84px"
                   label-position="right">
            <el-row>
              <el-col :span="24">
                <el-form-item label="单据类型">
                  <span>{{orderLogDetail.orderUnit}}</span>
                  <span v-if="!orderLogDetail.orderUnit || orderLogDetail.orderUnit === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="操作类别">
                  <span>{{orderLogDetail.billOperType}}</span>
                  <span v-if="!orderLogDetail.billOperType || orderLogDetail.billOperType === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="来源单据" v-if="orderLogDetail.billOperType === '新建单'">
                  <span>{{orderLogDetail.billOriginal}}</span>
                  <span v-if="!orderLogDetail.billOriginal || orderLogDetail.billOriginal === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
                <el-form-item label="原始单据" v-if="orderLogDetail.billOperType === '追加单'">
                  <span>{{orderLogDetail.billOriginal}}</span>
                  <span v-if="!orderLogDetail.billOriginal || orderLogDetail.billOriginal === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="服务类别">
                  <span>{{getShowName(3,orderLogDetail.billType)}}</span>
                  <span v-if="!orderLogDetail.billType || orderLogDetail.billType === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="服务类别一">
                  <span>{{getShowName(3,orderLogDetail.billType1)}}</span>
                  <span v-if="!orderLogDetail.billType1 || orderLogDetail.billType1 === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="服务类别二">
                  <span>{{getShowName(3,orderLogDetail.billType2)}}</span>
                  <span v-if="!orderLogDetail.billType2 || orderLogDetail.billType2 === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <!--<el-col :span="24">-->
                <!--<el-form-item label="客户来源">-->
                  <!--<span>{{orderLogDetail.orderExt.customerSource}}</span>-->
                  <!--<span v-if="orderLogDetail.orderExt.customerSource === ''"-->
                        <!--class="text-light">暂无信息</span>-->
                <!--</el-form-item>-->
              <!--</el-col>-->
              <el-col :span="24">
                <el-form-item label="单据联系电话">
                  <span>{{orderLogDetail.orderExt.billContactTelephone}}</span>
                  <span v-if="!orderLogDetail.orderExt.billContactTelephone || orderLogDetail.orderExt.billContactTelephone === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <!--<el-col :span="24">
                <el-form-item label="服务级别">
                  <span>{{orderLogDetail.billLevel}}</span>
                  <span v-if="orderLogDetail.billLevel === ''" class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>-->
            </el-row>
          </el-form>
        </div>
        <div>
          <div class="subtitle-border">派单信息</div>
          <el-form size="small"
                   label-width="84px"
                   label-position="right">
            <el-row>
              <el-col :span="24">
                <el-form-item label="处理方式">
                  <span>{{orderLogDetail.orderExt.handleMode}}</span>
                  <span v-if="!orderLogDetail.orderExt.handleMode || orderLogDetail.orderExt.handleMode === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="责任组织">
                  <span>{{getShowName(1,orderLogDetail.orderExt.responsibilityStore)}}</span>
                  <span v-if="!orderLogDetail.orderExt.responsibilityStore || orderLogDetail.orderExt.responsibilityStore === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="责任部门">
                  <span>{{getShowName(2,orderLogDetail.orderExt.responsibilityDepartment)}}</span>
                  <span v-if="!orderLogDetail.orderExt.responsibilityDepartment || orderLogDetail.orderExt.responsibilityDepartment === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="处理人员">
                  <span>{{orderLogDetail.orderExt.handler}}</span>
                  <span v-if="!orderLogDetail.orderExt.handler || orderLogDetail.orderExt.handler === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="处理人电话">
                  <span>{{orderLogDetail.orderExt.handleTelephone}}</span>
                  <span v-if="!orderLogDetail.orderExt.handleTelephone || orderLogDetail.orderExt.handleTelephone === ''"
                        class="text-light">暂无信息</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <div v-if="orderLogDetail.orderUnit === '咨询' || orderLogDetail.orderUnit === '投诉' || orderLogDetail.orderUnit === '救援'"
               class="subtitle-border">扩展信息</div>
          <div v-if="orderLogDetail.orderUnit === '咨询'">
            <el-form size="small"
                     label-width="84px"
                     label-position="right">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="信息来源">
                    <span>{{orderLogDetail.orderExt.informationSource}}</span>
                    <span v-if="!orderLogDetail.orderExt.informationSource || orderLogDetail.orderExt.informationSource === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="VOC来源">
                    <span>{{orderLogDetail.orderExt.ext1Name}}</span>
                    <span v-if="!orderLogDetail.orderExt.ext1Name || orderLogDetail.orderExt.ext1Name === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="活动名称">
                    <span>{{orderLogDetail.orderExt.activityName}}</span>
                    <span v-if="!orderLogDetail.orderExt.activityName || orderLogDetail.orderExt.activityName === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="派生线索">
                    <span>{{orderLogDetail.orderExt.derivativeCues}}</span>
                    <span v-if="!orderLogDetail.orderExt.derivativeCues || orderLogDetail.orderExt.derivativeCues === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="orderLogDetail.orderUnit === '投诉'">
            <el-form size="small"
                     label-width="84px"
                     label-position="right">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="信息来源">
                    <span>{{orderLogDetail.orderExt.complaintChannels}}</span>
                    <span v-if="!orderLogDetail.orderExt.complaintChannels || orderLogDetail.orderExt.complaintChannels === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item label="VOC来源">
                    <span>{{orderLogDetail.orderExt.customerComplaintSourceName}}</span>
                    <span v-if="!orderLogDetail.orderExt.customerComplaintSourceName || orderLogDetail.orderExt.customerComplaintSourceName === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="投诉级别">
                    <span>{{orderLogDetail.orderExt.complaintLevel}}</span>
                    <span v-if="!orderLogDetail.orderExt.complaintLevel || orderLogDetail.orderExt.complaintLevel === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="责任方">
                    <span>{{orderLogDetail.orderExt.responsibileParty}}</span>
                    <span v-if="!orderLogDetail.orderExt.responsibileParty || orderLogDetail.orderExt.responsibileParty === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="orderLogDetail.orderUnit === '救援'">
            <el-form size="small"
                     label-width="84px"
                     label-position="right">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="客户来源">
                    <span>{{orderLogDetail.orderExt.customerSource}}</span>
                    <span v-if="!orderLogDetail.orderExt.customerSource || orderLogDetail.orderExt.customerSource === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="救援地点">
                    <span>{{orderLogDetail.orderExt.rescueLocation}}</span>
                    <span v-if="!orderLogDetail.orderExt.rescueLocation || orderLogDetail.orderExt.rescueLocation === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="所在地标志物">
                    <span>{{orderLogDetail.orderExt.locationMarkers}}</span>
                    <span v-if="!orderLogDetail.orderExt.locationMarkers || orderLogDetail.orderExt.locationMarkers === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="转接保险公司">
                    <span>{{orderLogDetail.orderExt.transferInsuranceCompany}}</span>
                    <span v-if="!orderLogDetail.orderExt.transferInsuranceCompany || orderLogDetail.orderExt.transferInsuranceCompany === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="拖车目的地">
                    <span>{{getShowName(1,orderLogDetail.orderExt.trailerDestination)}}</span>
                    <span v-if="!orderLogDetail.orderExt.trailerDestination || orderLogDetail.orderExt.trailerDestination === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务类型">
                    <span>{{orderLogDetail.orderExt.billServiceType}}</span>
                    <span v-if="orderLogDetail.orderExt.billServiceType === '' || orderLogDetail.orderExt.billServiceType === null"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="是否用车来电">
                    <span>{{orderLogDetail.orderExt.isUsecarCall?'是':'否'}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
        <div v-if="orderLogDetail.orderUnit === '咨询'">
          <div v-if="orderLogDetail.orderExt.derivativeCues === '销售线索'">
            <div class="subtitle-border">销售线索</div>
            <el-form size="small"
                     label-width="84px"
                     label-position="right">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="意向车系">
                    <span>{{getShowName(6, orderLogDetail.orderExt.orderClue.ext1)}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.ext1 || orderLogDetail.orderExt.orderClue.ext1 === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="意向专营店">
                    <span>{{getShowName(7, orderLogDetail.orderExt.orderClue.ext2)}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.ext2 || orderLogDetail.orderExt.orderClue.ext2 === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="接触方式">
                    <span>{{orderLogDetail.orderExt.orderClue.contactMode}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.contactMode || orderLogDetail.orderExt.orderClue.contactMode === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="线索类型">
                    <span>{{orderLogDetail.orderExt.orderClue.clueType}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.clueType || orderLogDetail.orderExt.orderClue.clueType === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="信息来源大类">
                      <span>{{orderLogDetail.orderExt.orderClue.infosourceBigType}}</span>
                      <span v-if="!orderLogDetail.orderExt.orderClue.infosourceBigType || orderLogDetail.orderExt.orderClue.infosourceBigType === ''"
                            class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="信息来源小类">
                    <span>{{orderLogDetail.orderExt.orderClue.infosourceSmallType}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.infosourceSmallType || orderLogDetail.orderExt.orderClue.infosourceSmallType === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="计划购买时间">
                    <span>{{orderLogDetail.orderExt.orderClue.planBuyTime}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.planBuyTime || orderLogDetail.orderExt.orderClue.planBuyTime === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="意向级别">
                    <span>{{orderLogDetail.orderExt.orderClue.purposeLevel}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.purposeLevel || orderLogDetail.orderExt.orderClue.purposeLevel === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div v-if="orderLogDetail.orderExt.derivativeCues === '售后线索'">
            <div class="subtitle-border">售后线索</div>
            <el-form size="small"
                     label-width="84px"
                     label-position="right">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="信息来源">
                    <span>{{orderLogDetail.orderExt.orderClue.infoSource}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.infoSource || orderLogDetail.orderExt.orderClue.infoSource === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="推荐回厂专营店">
                    <span>{{getShowName(8,orderLogDetail.orderExt.orderClue.recommendShop)}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.recommendShop || orderLogDetail.orderExt.orderClue.recommendShop === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="期望联系时间">
                    <span>{{orderLogDetail.orderExt.orderClue.hopeContactTime}}</span>
                    <span v-if="!orderLogDetail.orderExt.orderClue.hopeContactTime || orderLogDetail.orderExt.orderClue.hopeContactTime === ''"
                          class="text-light">暂无信息</span>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="期望联系天数">
                    <span>{{orderLogDetail.orderExt.orderClue.hopeContactDays}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </el-scrollbar>
    </el-drawer>
  </div>
</template>
<script>
import { getOrderLogList, exportForm, exportOrderLog } from '@/api/autofillform/list'
import PageComponent from '../components/PageComponent'
export default {
  components: { PageComponent },
  data () {
    return {
      pageBuild: {
        page_size: 10,
        total: 0,
        currentPage: 1,
        fileName: ''
      },
      drawer: false,
      direction: 'rtl',
      // 一、主体区域
      // 1.表格内数据
      tableData: [],
      seats_options: [],
      skillGroup_options: [],
      queryDate: '',
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime()
          if (maxDate) {
            this.choiceDate = ''
          }
        },
        disabledDate: (time) => {
          if (this.choiceDate && this.choiceDate.length > 0) {
            const one = 30 * 24 * 3600 * 1000
            const minTime = this.choiceDate - one
            const maxTime = this.choiceDate + one
            return time.getTime() < minTime || time.getTime() > maxTime
          }
        }
      },
      phoneSelectOptions: [
        {
          value: 'all',
          label: '全部'
        }, {
          value: '0',
          label: '无电话'
        }, {
          value: '1',
          label: '有电话'
        }
      ],
      searchField: '',
      skillGroup: 'all',
      seatsId: 'all',
      phoneSelect: 'all',
      orderLogDetail: {
        clientName: '',
        clientPhone: '',
        clientSex: '',
        ownerName: '',
        carId: '',
        carVin: '',
        carBrand: '',
        carSeries: '',
        carModel: '',
        sessionRemark: '',
        sessionRequire: '',
        sessionQuestion: '',
        sessionAnswer: '',
        orderUnit: '2',
        billOperateType: '1',
        billType: '',
        billLevel: '',
        billOriginal: '',
        orderExt: {
          billType: '',
          operationType: '',
          billServiceType: '',
          customerSource: '',
          billContactTelephone: '',
          handleMode: '',
          responsibilityStore: '',
          responsibilityDepartment: '',
          handler: '',
          handleTelephone: '',
          rescueLocation: '',
          locationMarkers: '',
          transferInsuranceCompany: '',
          trailerDestination: '',
          extendServiceType: '',
          isUsecarCall: false,
          informationSource: '',
          activityName: '',
          derivativeCues: '1',
          complaintChannels: '',
          complaintLevel: '',
          customerComplaintSource: '',
          responsibileParty: '',
          sessionId: '',
          billOriginal: '',
          orderClue: {
            sessionId: '',
            contactMode: '',
            clueType: '',
            infosourceBigType: '',
            infosourceSmallType: '',
            planBuyTime: '',
            purposeLevel: '',
            infoSource: '',
            recommendShop: '',
            hopeContactTime: '',
            hopeContactDays: ''
          }
        }
      },
      dialogVisible: false,
      headers: { Authorization: this.getToken(), 'X-TENANT-ID': this.getCTenantId() },
      uploadUrl: window.$envUtils('VUE_APP_BASE_URL') + window.$envUtils('VUE_APP_AFF_SERVICE') + '/nissan/orderLog/importFillform',
      fileName: '',
      isDisabled: false
    }
  },
  methods: {
    getShowName (type, strData) {
      if (strData && strData !== '') {
        const o = JSON.parse(strData)
        if (type === 1) {
          return o.dutyOrgName
        } else if (type === 2) {
          return o.requOrhname
        } else if (type === 3 && o && o.length > 0) {
          let strName = ''
          for (let i = 0; i < o.length; i++) {
            strName += o[i].fullName + ','
          }
          strName = strName.substr(0, strName.length - 1)
          return strName
        } else if (type === 6) {
          return o.intentionSeriesName
        } else if (type === 7) {
          return o.intentionDlrName
        } else if (type === 8) {
          return o.backDlrName
        }
      } else {
        return ''
      }
    },
    searchOrderLogList (pageNumber) {
      var that = this
      if (that.queryDate === '' || that.queryDate.length === 0) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        end.setTime(end.getTime() + 3600 * 1000 * 24)
        that.queryDate = [start, end]
      }
      const params = {
        page: pageNumber,
        limit: this.pageBuild.page_size,
        searchField: this.searchField,
        seatsIds: [],
        sessionIds: [],
        skillGroupIds: [],
        queryDate: that.queryDate,
        phoneSelect: that.phoneSelect,
        me: '2'
      }
      var arr = []
      var skillGroupArr = []
      if (that.skillGroup === 'all') {
        if (that.seatsId === 'all') {
          that.skillGroup_options.forEach(val => {
            skillGroupArr.push(val.id)
          })
          arr = null
        } else {
          arr.push(that.seatsId)
          skillGroupArr = null
        }
      } else {
        if (that.seatsId === 'all') {
          that.seats_options.forEach(val => {
            arr.push(val.id)
          })
          skillGroupArr = null
        } else {
          arr.push(that.seatsId)
          skillGroupArr = null
        }
      }
      if (arr !== null) {
        params.seatsIds = arr
      }
      if (skillGroupArr !== null) {
        params.skillGroupIds = skillGroupArr
      }
      getOrderLogList(JSON.stringify(params)).then(response => {
        this.pageBuild.total = response.data.data.totalProperty
        this.tableData = response.data.data.root
      }).catch(response => {
        this.tableData = []
      })
    },
    openDetail (item) {
      this.drawer = true
      this.orderLogDetail = item
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    getToken () {
      return localStorage.getItem('Authorization')
    },
    // 获取租户id
    getCTenantId () {
      return localStorage.getItem('X-TENANT-ID')
    },
    getFileName (file) {
      var end = file.name.lastIndexOf('.')
      var fileName = file.name.substring(0, end)
      // eslint-disable-next-line eqeqeq
      if (this.fileName.length == 0) {
        this.fileName = fileName
      }
    },
    exportOrderLogList () {
      var that = this
      that.isDisabled = true
      var params = { searchField: that.searchField }
      exportForm(params).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '填单' + '(' + (new Date()).valueOf() + ').xlsx'
        that.exportExcel(blob, fileName)
        that.isDisabled = false
      }).catch(err => {
        console.log(err)
        that.isDisabled = false
      })
    },
    exportExcel (blob, fileName) {
      if ('download' in document.createElement('a')) { // 非IE下载
        const elink = document.createElement('a')
        elink.download = fileName
        elink.style.display = 'none'
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        URL.revokeObjectURL(elink.href)
        document.body.removeChild(elink)
      } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName)
      }
    },
    changeSeatsGroup () {
      const that = this
      var strSeatIds = ''
      that.seats_options = []
      that.seatsId = 'all'
      that.skillGroup_options.forEach(function (item, index, arr) {
        // eslint-disable-next-line eqeqeq
        if (that.skillGroup == 'all' && item.skillUsers) { // 选择了所有坐席组，将所有坐席遍历到坐席选择框中
          item.skillUsers.forEach(function (obj, idx, array) {
            if (!strSeatIds.includes(obj.id)) { // 排除重复坐席
              // eslint-disable-next-line no-const-assign
              strSeatIds = strSeatIds + ',' + obj.id
              that.seats_options.push(obj)
            }
          })
        }
        // eslint-disable-next-line eqeqeq
        if (that.skillGroup == item.id) { // 选择了某个坐席组，将某个坐席组中的坐席遍历到坐席选择框中
          that.seats_options = item.skillUsers
        }
      })
    },
    getCustomerGroupInfo () {
      const that = this
      that.skillGroup_options = []
      // process.env.VUE_APP_AFF_SERVICE.substring(1, process.env.VUE_APP_AFF_SERVICE.length)
      that.$autoFillFormAuthUtis.autoFillFormSkillGroupList(window.$envUtils('VUE_APP_AFF_SERVICE').substring(1, process.env.VUE_APP_AFF_SERVICE.length), '101100', function (res) {
        const data = res.data.data
        that.skillGroup_options = data
        that.changeSeatsGroup()
        that.searchOrderLogList(1)
      })
    },
    currentChange (pageNumber) {
      this.pageBuild.currentPage = pageNumber
      this.searchOrderLogList(pageNumber)
    },
    exportOrderLog() {
      var that = this
      that.isDisabled = true
      if (that.queryDate === '' || that.queryDate.length === 0) {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
        end.setTime(end.getTime() + 3600 * 1000 * 24)
        that.queryDate = [start, end]
      }
      const params = {
        searchField: this.searchField,
        seatsIds: [],
        skillGroupIds: [],
        queryDate: that.queryDate,
        phoneSelect: that.phoneSelect
      }
      var arr = []
      var skillGroupArr = []
      if (that.skillGroup === 'all') {
        if (that.seatsId === 'all') {
          that.skillGroup_options.forEach(val => {
            skillGroupArr.push(val.id)
          })
          arr = null
        } else {
          arr.push(that.seatsId)
          skillGroupArr = null
        }
      } else {
        if (that.seatsId === 'all') {
          that.seats_options.forEach(val => {
            arr.push(val.id)
          })
          skillGroupArr = null
        } else {
          arr.push(that.seatsId)
          skillGroupArr = null
        }
      }
      if (arr !== null) {
        params.seatsIds = arr
      }
      if (skillGroupArr !== null) {
        params.skillGroupIds = skillGroupArr
      }
      exportOrderLog(params).then(res => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        const fileName = '工单导出数据' + '(' + (new Date()).valueOf() + ').xlsx'
        that.exportExcel(blob, fileName)
        setTimeout(function () {
          that.isDisabled = false
        }, 1000)
      }).catch(err => {
        console.log(err)
        setTimeout(function () {
          that.isDisabled = false
        }, 1000)
      })
    }
  },
  mounted () {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    end.setTime(end.getTime() + 3600 * 1000 * 24)
    this.queryDate = [start, end]
    this.getCustomerGroupInfo()
  }
}
</script>

<style lang="scss" scoped>
.title {
  margin-top: 12px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e1e3e6;
  color: #222222;
}
.mg_bt_10 {
  margin-bottom: 10px;
}
.mg_lf_10 {
  margin-left: 10px;
}
.el-table .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fafafa;
}
.wrapper {
  height: 100%;
}
.scrollbar-wrap {
  height: calc(100% - 205px);
}
.table-tool {
  margin-top: 0;
  margin-bottom: 10px;
}
.el-drawer__wrapper {
  ::v-deep .el-drawer__header {
    font-size: 16px;
    color: #333;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 10px;
    margin-bottom: 0;
    span {
      &:focus {
        outline: none;
      }
    }
  }
  ::v-deep .el-drawer__body {
    height: calc(100% - 56px);
    padding: 0 20px;
    .el-form {
      margin-right: 20px;
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          font-size: 12px;
          color: #333;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .el-form-item__content {
          line-height: 32px;
          font-size: 12px;
          color: #666;
          word-break: break-all;
          line-height: 1.8;
          padding-top: 7px;
        }
      }
    }
  }

  ::v-deep .el-drawer.rtl {
    width: 370px !important;
    display: block;
  }
}
.subtitle-border {
  font-size: 16px;
  color: #333;
  margin-top: 10px;
  margin-bottom: 10px;
  &:before {
    height: 14px;
  }
}
.el-scrollbar {
  .el-scrollbar__wrap {
    padding-bottom: 20px;
  }
}
</style>
